import { render, staticRenderFns } from "./historyQuest.vue?vue&type=template&id=69ada17c&scoped=true&"
import script from "./historyQuest.vue?vue&type=script&lang=js&"
export * from "./historyQuest.vue?vue&type=script&lang=js&"
import style0 from "./historyQuest.vue?vue&type=style&index=0&id=69ada17c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ada17c",
  null
  
)

export default component.exports